import Cookies from 'js-cookie';
import isbot from 'isbot';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-top-bar').forEach((notice) => {
    const main = document.querySelector('#main');
    const noticeId = notice.getAttribute('id');
    const expiresHours = notice.getAttribute('data-expires')
      ? parseFloat(notice.getAttribute('data-expires'))
      : 2;
    const expiresDays = expiresHours / 24;

    function init() {
      if (!isbot(navigator.userAgent)) {
        if (Cookies.get(noticeId) === undefined) {
          open();
        }
      }
    }

    function open() {
      notice.removeAttribute('hidden');
      main.classList.add('is-top-bar-active');
    }

    function close() {
      notice.setAttribute('hidden', 'true');
      main.classList.remove('is-top-bar-active');
      Cookies.set(noticeId, 1, { expires: expiresDays });
    }

    if (notice.querySelector('.site-top-bar__close')) {
      notice
        .querySelector('.site-top-bar__close')
        .addEventListener('click', (e) => {
          close();
        });
    }

    init();
  });
});
